$(document).ready(function () {

	/**
	 * Checks header height and sets CSS variable that updates on resize
	 */
	function headerHeight() {
		document.documentElement.style.setProperty('--headerHeight', "".concat($('header').outerHeight(), "px"));
	};

	window.addEventListener('resize', headerHeight);
	headerHeight(); 

	// Top Section Animated Dots
	//- About Video Dots Animation
	let num = 0;
	function timeoutDotsAnimation() {
		setTimeout(function () {
			const el = $('#aboutProductBanner .about-product__item');
			// console.log('num', num);

			(num === 4) ? num = 1 : num++;

			el.removeClass('about-product__item--anim');
			$('#aboutProductBanner .about-product__item[data-num=' + num + ']').addClass('about-product__item--anim');
			timeoutDotsAnimation();
		}, 3000);
	}

	timeoutDotsAnimation();

	/**
	 * Calc height of sticky CTA to adjust position
	 */
	let stickyCta = $('#buyNowSticky');

	if($(stickyCta).length) {
		function stickyCtaTopPos() {	
			let stickyCtaHeight = Math.floor($(stickyCta).outerHeight());
	
			document.documentElement.style.setProperty('--stickyCtaTopPos', stickyCtaHeight + 'px');

			// console.log(stickyCtaHeight);
		}

		stickyCtaTopPos();
	
		//- seTimeout for window resizing
		let resizeTimer;
	
		$(window).on('resize', function(e) {
			clearTimeout(resizeTimer);
	
			resizeTimer = setTimeout(function() {
				stickyCtaTopPos();
			}, 250);
	
		});
	}
	
	//salesBanner
	if ($('#salesBanner').length) {
		let salesBannerHeight = Math.floor($('#salesBanner').height());
		if ($('#salesBanner').hasClass('isStick')) {
			$('#salesBanner, .cta.btn:not(.param), #promoBanner, #salesBadge').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top - salesBannerHeight
				}, 1000);
			});
		} else {
			$('#salesBanner, .cta.btn:not(.param), #promoBanner, #salesBadge').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top
				}, 1000);
			});
		}
	} else {
		//// Take to shooping cart ////
		$('.cta.btn:not(.param), #promoBanner, #salesBadge').on('click', function (event) {
			if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
				$('html, body').animate({
					scrollTop: $("#promoBannerAnchor").offset().top
				}, 1200);
			} else {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top
				}, 1200);
			}
		});
	}
	
	/////////////////////////////// video listener ///////////////////////////////////////
	if ($('#topVSL').length > 0) {
		videojs('topVSL').ready(function () {
			this.on('timeupdate', function () {
				if (this.currentTime() >= (60 * 7)) {
					$('.videoWrapper .cta-wrap').addClass('show');
				}
				// console.log(this.currentTime());
			})
		});
	}

	/////////////////////////////// cart ///////////////////////////////
	const
		body = $('body'),
		cartSummary = $('.cart__summary'),
		disclaimerBox = $('#disclaimerBox'),
		disclaimerTrigger = $('#disclaimerTrigger'),
		subscribeMode = $('.purchaseMode'),
        subscribeModeDoubleSS = $('#subscribeModeDoubleSS');

	//- Select Subscribe option if click on disclaimer box title
	disclaimerTrigger.on("click", function () {
		let checkbox = $('#subscribeCheckbox');
		let cartBtn = $('#cartCta');

		checkbox.toggleClass('checked');
		cartBtn.toggleClass('disabled');

		if(checkbox.hasClass('alert')) {
            $('.subscribe-box__alert').removeClass('show');
            checkbox.removeClass('alert');
        }
	})

	// Detect Touch event
	if ("ontouchstart" in document.documentElement) {
		body.addClass('touch');

		// close disclaimer box
		$('#closeDisclaimer').on('click', function () {
			disclaimerBox.addClass('hide').removeClass('show');
		});
	}

	// close disclaimer box
	$('#closeDisclaimer').on('click', function () {
		disclaimerBox.removeClass('subscribe-box__disclaimer--open');
	});

	// Subscribe Mode
	$('.subscribe-box__default').on('click', function () {
		let thisBtn = $(this),
			cartBtn = $('#cartCta'),
			checkbox = $('#subscribeCheckbox');

		$('.subscribe-box__default').removeClass('active');
		thisBtn.addClass('active');

		disclaimerBox.addClass('subscribe-box__disclaimer--open');

		//- reset all UIs
		if (cartBtn.hasClass('disabled')) {
			cartBtn.removeClass('disabled');
		}

		if (checkbox.hasClass('checked')) {
			checkbox.removeClass('checked');
		}

		//- set 'data-subscribe' value + control UI
		if (thisBtn.hasClass('subscribe')) {
			subscribeMode.attr('data-subscribe', 'true');

			cartSummary.addClass('cart__summary--subscribe');

			if ($(body).hasClass('show-promoBanner')) {
				body.addClass('show-promoBanner--club');
			}

			if (!cartBtn.hasClass('disabled')) {
				cartBtn.addClass('disabled');
			}

			if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
				disclaimerBox.addClass('subscribe-box__disclaimer--open');
			}

			// on touch screens
			if ("ontouchstart" in document.documentElement && disclaimerBox.hasClass('hide')) {
				disclaimerBox.removeClass('hide').addClass('show');
			}

		} else {
			subscribeMode.attr('data-subscribe', 'false');

			cartSummary.removeClass('cart__summary--subscribe');
			
			if ($(body).hasClass('show-promoBanner')) {
				body.removeClass('show-promoBanner--club');
			}

			if (cartBtn.hasClass('disabled')) {
				cartBtn.removeClass('disabled');
			}

			if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
				disclaimerBox.removeClass('subscribe-box__disclaimer--open');
			}

			// on touch screens
			if ("ontouchstart" in document.documentElement && disclaimerBox.hasClass('show')) {
				disclaimerBox.removeClass('show').addClass('hide');
			}
		}

		$('.cart__product.active').trigger("click");
	});

    /**
     * Subscribe Mode - chechbox mode
     */    
    $('#subscribeInput').on('click', function (check) {
        // console.log($(this).is(":checked"));
        
        let checkboxType;

        if ($('#orderNow').attr('data-subscribe') === 'false') {
            checkboxType = true;

            subscribeOn();

            // if(ctaSubscribeAndSaveText != '') {
            //     $('#cartCta').html(ctaSubscribeAndSaveText);
            // }

			cartSummary.addClass('cart__summary--subscribe');

            if(subscribeModeDoubleSS.length) {
                $('#cartCta').addClass('disabled');
            }
            
        } else {
            checkboxType = false;
            
            subscribeOff();

            // if(ctaSubscribeAndSaveText != '') {
            //     $('#cartCta').html(ctaText);
            // }

			cartSummary.removeClass('cart__summary--subscribe');

            if(subscribeModeDoubleSS.length) {
                $('#cartCta').removeClass('disabled');

                //- Reset S&S click on disable alert
                if($('#subscribeCheckbox').hasClass('alert')) {
                    $(".subscribe-box__alert").removeClass('show');
                    $("#subscribeCheckbox").removeClass('alert');
                }

                if($('#subscribeCheckbox').hasClass('checked')) {
                    $("#subscribeCheckbox").removeClass('checked');
                }
            }
        }

        this.setAttribute('checked', checkboxType);

        $('.cart__product.active').trigger("click");
    });

    $('#stateSSOn').on('click', function (check) {        
        subscribeOn();
        
        $('#subscribeInput').attr('checked', 'true');

        $('.cart__product.active').trigger("click");
    })

    function subscribeOn() {
        $('#orderNow').attr('data-subscribe', 'true');
        subscribeMode.attr('data-subscribe', 'true');
        disclaimerBox.addClass('subscribe-box__disclaimer--open');

		if ($(body).hasClass('show-promoBanner')) {
			body.addClass('show-promoBanner--club');
		}

		$('html, body').animate({
			scrollTop: $("#orderNow").offset().top
		}, 1000);
    }

    function subscribeOff() {
        $('#orderNow').attr('data-subscribe', 'false')
        subscribeMode.attr('data-subscribe', 'false');

        // on touch screens
        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }

		if ($(body).hasClass('show-promoBanner')) {
			body.removeClass('show-promoBanner--club');
		}
    }

	function activeProduct() {
		let thisProduct = $(this);
		let subscribeAttr = $('.purchaseMode').attr('data-subscribe');
		let unit = thisProduct.attr('data-units');
		let ribbon = thisProduct.attr('data-ribbon');

		const btnUnitsValue = $('#btnUnitsValue');

		let price, retail, saving, link, subscription, sale, shipping;
		
		price = 'amount';
		retail = 'retail';
		saving = 'saving';
		link = 'tracker';
		sale = '';
		shipping = 'shipping';

		if (subscribeAttr === 'true') {
			subscription = 'club-';

		} else {
			subscription = '';
		}

		if ($('body').hasClass('show-promoBanner')) {
			sale = 'sale-'

		} else {
			sale = '';
		}

		// console.log('data-' + sale + subscription + price);

		$('.cart__product').removeClass('active');
		thisProduct.addClass('active');

		if (!$('.cart--centeredSlides').length) {
			$('.current__value').html(thisProduct.attr('data-' + sale + subscription + price + ''));
			$('.retail__value').html(thisProduct.attr('data-' + sale + subscription + retail + ''));
			$('.internet__value').html(thisProduct.attr('data-' + price + ''));
			$('.saving__value').html(thisProduct.attr('data-' + sale + subscription + saving + ''));
		} else {
			$('.cart__product').each(function(){
				$(this).find('.current__value').html($(this).attr('data-' + sale + subscription + price + ''));
				$(this).find('.retail__value').html($(this).attr('data-' + sale + subscription + retail + ''));
				$(this).find('.internet__value').html($(this).attr('data-' + price + ''));
				$(this).find('.saving__value').html($(this).attr('data-' + sale + subscription + saving + ''));
			});
			$('#cartShipping').html($(this).attr('data-' + subscription + shipping + ''));
		}

		//- print ribbon value
		if ($('#ribbon').length) {
			$('.ribbon__value').html(ribbon);
		}

		btnUnitsValue.html(unit);

		// Images to show according to the product unit
		$('.cart__image-item').removeClass('show').addClass('hide');
		$('.cart__image-item--' + unit + '').removeClass('hide').addClass('show');

		btnUnitsValue.html(unit);

		//- handle CTA by ID
		let param = $('#cartCta').attr('data-param');
		$('#cartCta').attr('href', thisProduct.attr('data-' + sale + subscription + link + '') + param);

		/**
		 * Calculate Price Per Day
		 */

		let pricePerDay, 
			month = 30, 
			days,
			amount = thisProduct.attr('data-' + sale + subscription + price + '');

		function calcPricePerDay(amount, unit, month) {
			// console.log('amount', amount);
			// console.log('unit', unit);
			// console.log('month', month);

			//- Split amount and convert into number
			let amountNum = amount.replace('$', '');
			
			//- Calculate months into days
			days = unit * month;
			// console.log('days', days);

			pricePerDay = (amountNum / days).toFixed(2);

			// console.log('pricePerDay', pricePerDay);

			$('.price-per-day__value').html('$' + pricePerDay);
			
		}

		calcPricePerDay(amount, unit, month);

		/**
		 * Handle Strawberry Image banner when under sale mode
		 */
		const bannerImgEl = $('#bannerImage'); //- define Image Element
		const bannerImgPath = 'https://dtjlhiahlv53j.cloudfront.net/assets/nucific/';
		let bannerImgD, bannerImgT, bannerImgM, bannerImgVersion;

		//- Check if we're on sale time period but not under club prices
		if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
			bannerImgD = bannerImgEl.attr('data-sale-image-d');
			bannerImgT = bannerImgEl.attr('data-sale-image-t');
			bannerImgM = bannerImgEl.attr('data-sale-image-m');

		} else {
			bannerImgD = bannerImgEl.attr('data-image-d');
			bannerImgT = bannerImgEl.attr('data-image-t');
			bannerImgM = bannerImgEl.attr('data-image-m');
		}

		//- manipulate banner image size
		if (window.innerWidth > 1024) {
			bannerImgVersion = bannerImgD;

		} else if (window.innerWidth < 768) {
			bannerImgVersion = bannerImgM;

		} else {
			bannerImgVersion = bannerImgT;
		}

		// console.log(bannerImgEl.src = bannerImgPath + bannerImg + bannerImgVersion + '.jpg');

		bannerImgEl.attr('src', bannerImgPath + bannerImgVersion);
	};

	$('.cart__product').on('click', activeProduct);
	$('.cart__product.active').trigger("click");

	/**
	 * Activate slider when cart_layout_options == 'centered-card-slides'
	*/
	if ($('.cart--centeredSlides').length) {
		$('.cart__products').slick({
			infinite: false,
			centerMode: true,
			mobileFirst: true,
			arrows: false,
			responsive: [
			  {
				breakpoint: 0,
				settings: {
				  slidesToShow: 1,
				  centerPadding: '30px'
				}
			  },
			  {
				breakpoint: 374,
				settings: {
				  slidesToShow: 1,
				  centerPadding: '80px'
				}
			  },
			  {
				breakpoint: 768,
				settings: {
				  slidesToShow: 3,
				  centerPadding: '50px'
				}
			  },
			  {
				breakpoint: 992,
				settings: {
				  slidesToShow: 3,
				  centerPadding: '80px'
				}
			  }
			]
		});

		let initialRun = false;
		if (!false && $(window).width() < 768) {
			const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
			$('.cart__products').slick('slickGoTo', currentActiveCard);
			initialRun = true;
		}

		$('.cart__products').on('setPosition', function(){
			if ($(window).width() <= 768) {
				const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
				const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));
				$('.cart__product').removeClass('active');
				$('.cart__product').eq(currentActiveCard).addClass('active');
				$('.cart__product.active').trigger("click");
				
				if (slickActiveCard != currentActiveCard) {
					$('.cart__product').removeClass('active');
					$('.cart__product').eq(slickActiveCard).addClass('active');
					$('.cart__product.active').trigger("click");
				}
			}
		});

		$('.cart__products').on('click', function(){
			if ($(window).width() < 768) {
				const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
				const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));

				if (slickActiveCard != currentActiveCard) {
					$('.cart__products').slick('slickGoTo', currentActiveCard);
				}
			}
		});
	}

	//---------------------------------------Reviews----------------------------------------//
	/**
	 * Reviews Video
	 */
	if ($('#reviewsVideoSlider').length) {
		const toShowOnMobile = $('#reviewsVideoSlider').data('show-mobile');
		const toShowOnDesktop = $('#reviewsVideoSlider').data('show-desktop');

		$('#reviewsVideoSliderList').slick({
			infinite: false,
			slidesToShow: toShowOnMobile,
			adaptiveHeight: false,
			speed: 1000,
			centerMode: true,
			centerPadding: '30px',
			arrows: false,
			dots: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: toShowOnDesktop,
						centerMode: toShowOnDesktop > 1 ? false : true,
					}
				}
			]
		});
	}
	
	//---------------------------------------End Reviews----------------------------------------//

	//////////////////////////////// blends slider /////////////////////////////////
	//- Content
	$('.blendsSliderText').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		dots: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 8000,
		centerMode: true,
		pauseOnHover: true,
		pauseOnDotsHover: true,
		adaptiveHeight: true,
		appendDots: $(".blendsNav"),
		customPaging: function (slick, index) {
			var targetImage = slick.$slides.eq(index).data('img'),
				targetAlt = slick.$slides.eq(index).data('alt'),
				targetTitle = slick.$slides.eq(index).find('.blendsSliderText__title').html();
			return '<img data-src="https://dtjlhiahlv53j.cloudfront.net/assets/nucific/' + targetImage + '" alt="' + targetAlt + '" class="blendsNav__img lazyload"/><div class="blendsNav__title">' + targetTitle + '</div>';
		}
	});

	//////////////////////// hamburger ////////////////////////
	(function () {
		var hamburger = {
			navToggle: document.querySelector('.nav-toggle'),
			nav: document.getElementById('nav'),
			salesBanner: document.querySelector('.salesBanner'),

			doToggle: function (e) {
				e.preventDefault();
				this.navToggle.classList.toggle('expanded');
				this.nav.classList.toggle('expanded');
				this.salesBanner.classList.toggle('hide');
			}
		};

		if ($('#nav').length) {
			hamburger.navToggle.addEventListener('click', function (e) { hamburger.doToggle(e); });
		}

	}());

	//- Set current Year to footer Copyright
	let thisDate = new Date();
	$('#year').html(thisDate.getFullYear());

	/**
	 * Ticker 
	 */
	let counter;

	// recentlyBought();
	function recentlyBought() {
		const ticker = $('#ticker');
		const purchaseBox = $('#purchaseBox');
		counter = 0;

		// storage returned strings from getPurchases(), passing provided purchases array
		let purchasesArray = getPurchases(purchases);

		// console.log(purchasesArray.length); //- 300

		function appendRecentlyBought(item) {
			purchaseBox.html(item); //- change text of purchaseBox with delay of 9s
		}

		function animateTicker() {
			appendRecentlyBought(purchasesArray[counter]);

			// console.log('For item = ' + counter + ': ' + purchasesArray[counter]);

			ticker.addClass('anim-in').delay(2500).queue(function () {
				$(this).removeClass('anim-in').dequeue();

				counter++;

				// Reset counter when reach the end
				if (counter >= purchasesArray.length) {
					counter = 0;
				}

				let delayTime = (Math.floor((Math.random() * ((12 - 5) + 1) + 5)) * 1000);

				// console.log('delayTime = ' + delayTime);

				setTimeout(function () {
					animateTicker();
				}, delayTime);
			})
		}

		animateTicker();
	}

	setTimeout(function () {
		recentlyBought()
	}, 4000);


	/**
	 * https://shancarter.github.io/mr-data-converter/ (JSON - Row Arrays)
	 */
	var purchases =[
		['Linda', '1', 'FALSE'], ['Jeanetta', '3', 'TRUE'], ['Leilani', '1', 'FALSE'], ['Susan', '6', 'FALSE'], ['Rennan', '1', 'TRUE'], ['Eli', '3', 'TRUE'], ['Kathleen', '1', 'FALSE'], ['Jeanie', '3', 'TRUE'], ['Natalie', '1', 'FALSE'], ['Candy', '6', 'TRUE'], ['Brooke', '1', 'TRUE'], ['Matthew', '3', 'FALSE'], ['Carrie', '3', 'FALSE'], ['Craig', '6', 'FALSE'], ['Rosa', '3', 'TRUE'], ['Ana', '1', 'FALSE'], ['Crystal', '1', 'FALSE'], ['Regina', '6', 'TRUE'], ['John', '3', 'FALSE'], ['Afsoon', '1', 'TRUE'], ['Lonnie', '1', 'TRUE'], ['Don', '3', 'TRUE'], ['Susan', '1', 'TRUE'], ['Beth', '6', 'FALSE'], ['Barbara', '1', 'TRUE'], ['Robert', '3', 'TRUE'], ['Christine', '6', 'FALSE'], ['Marvette', '1', 'FALSE'], ['Christy', '1', 'FALSE'], ['Sharon', '6', 'FALSE'], ['Rena', '6', 'TRUE'], ['Joann', '3', 'FALSE'], ['Marcus', '1', 'FALSE'], ['Audrey', '1', 'TRUE'], ['Melony', '1', 'TRUE'], ['Debbie', '6', 'FALSE'], ['Fida', '3', 'FALSE'], ['Gary', '6', 'TRUE'], ['Charne', '1', 'FALSE'], ['Tannaz', '3', 'FALSE'], ['Richard', '3', 'FALSE'], ['Colette', '6', 'FALSE'], ['Pam', '1', 'TRUE'], ['Mashell', '3', 'TRUE'], ['Donald', '6', 'FALSE'], ['Cloie', '1', 'TRUE'], ['Debra', '3', 'FALSE'], ['Ren', '1', 'TRUE'], ['Annamae', '1', 'FALSE'], ['Phuoc', '1', 'FALSE'], ['Richard', '6', 'TRUE']
	];
	/**
	* getPurchases() - loop through purchases array, manipulate each index and storage new array into 'itemsArray'
	*/


	function getPurchases(items) {
		var itemsArray = [];

		for (let i = 0; i < items.length; i++) {
			if (purchases[i][2] == 'TRUE') {
				itemsArray.push(`${purchases[i][0]} subscribed and saved on ${items[i][1]} ${items[i][1] == 1 ? 'bottle' : 'bottles'} of BioX4`);
			} else if (purchases[i][2] == 'FALSE') {
				itemsArray.push(`${purchases[i][0]} bought ${items[i][1]} ${items[i][1] == 1 ? 'bottle' : 'bottles'} of BioX4`);
			}
		}

		// console.log(itemsArray); //- all 'items' indices (300), already manipulated to the required string

		// https://bost.ocks.org/mike/shuffle/
		let currentIndex = itemsArray.length, randomIndex;

		// While there remain elements to shuffle...
		while (currentIndex != 0) {

			// Pick a remaining element...
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex--;

			// And swap it with the current element.
			[itemsArray[currentIndex], itemsArray[randomIndex]] = [itemsArray[randomIndex], itemsArray[currentIndex]];
		}

		//   console.log(itemsArray); //- all 'items' indices (8), already manipulated to the required string

		return itemsArray;
	}

	/**
	 * ticker UI position based on sticky CTA
	 */
	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	document.addEventListener('scroll', function () {
		const ticker = $('.ticker--topLeft');

		if (ticker.length) {
			const header = document.querySelector('header');

			if (isInViewport(header) == true) {
				document.documentElement.style.setProperty('--tickerTopPos', $('header').outerHeight() + 15 + 'px');
			} else {
				document.documentElement.style.setProperty('--tickerTopPos', '15px');
			}
		}
	});

	const offersTicker = $('#offersTicker');

	if (offersTicker.length) {
		offersTicker.slick({
			dots: false,
			arrows: true,
			prevArrow: '<i class="fa offersTicker__arrows offersTicker__arrowLeft fa-chevron-left"></i>',
        	nextArrow: '<i class="fa offersTicker__arrows offersTicker__arrowRight fa-chevron-right"></i>',
			adaptiveHeight: true,
			speed: 500,
			autoplay: true,
			autoplaySpeed: 3000
		});
	}
});

